import { render, staticRenderFns } from "./PlanBadge.vue?vue&type=template&id=794cc831&scoped=true"
import script from "./PlanBadge.vue?vue&type=script&lang=js"
export * from "./PlanBadge.vue?vue&type=script&lang=js"
import style0 from "./PlanBadge.vue?vue&type=style&index=0&id=794cc831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794cc831",
  null
  
)

export default component.exports